import type React from 'react';
import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { StarsInput } from '@/components/ui/stars-input';
import { getRatingLabel } from '@/features/estates-property/constants/rating-label';
import { i18n } from '@/lib/i18n';

export const FieldRating = <T extends FieldValues>({
  name,
  methods,
}: {
  name: Path<T>;
  methods: UseFormReturn<T>;
}) => {
  return (
    <Controller
      {...methods}
      name={name}
      render={({ field: { onChange, ...field }, fieldState: { error } }) => (
        <div>
          <div className="flex w-1/4 items-start gap-[10px]">
            <StarsInput
              {...field}
              onChange={(ev) => {
                onChange(Number(ev.target.value));
              }}
            />
            <p className="text-base text-primary">{field.value}</p>
          </div>
          {error ? (
            <p
              role="alert"
              className="select-none overflow-auto py-1 text-xs text-danger opacity-0 motion-safe:animate-slide-in"
              style={{ '--delay': '0s' } as React.CSSProperties}
            >
              {i18n.t('requireWarning')}
            </p>
          ) : (
            <p className="py-1 text-xs text-primary opacity-50">
              {getRatingLabel(Number(field.value))}
            </p>
          )}
        </div>
      )}
    />
  );
};
